// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a000ef2f","453":"80277a13"}[chunkId] + ".chunk.js";
};